import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';

class Logout extends Component {
    static muiName = 'FlatButton';

    render() {
        return (
            <FlatButton {...this.props} label="Logout" />
        );
    }
}

export default Logout;


// WEBPACK FOOTER //
// ./src/components/Logout/index.js